import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  name: "",
  dashboardPage: "Dashboard",
  breadCrumbs: [{label: 'DASHBOARD',link:''}],
  currentPagination: 1,
  paginationReset: true,
  appErrors: [],
  updateGlobalArrival: false,
  downloadState: {
    progress: false,
  },
  index:0,
  action:false
};

export const authSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state = action.payload;
    },
    setPage: (state, action) => {
      state.dashboardPage = action.payload;
      if (
        !location.pathname
          .split("/")
          .includes(
            String(state.dashboardPage).toLowerCase().split(" ").join("-")
          )
      ) {
        console.log("resetting");
        state.currentPagination = 1;
      } else {
        if (location.pathname.includes("edit")) {
          state.paginationReset = false;
        }
      }
    },
    setBreadCrumb: (state, action) => {
      state.breadCrumbs = action.payload;
    },
    setCurrentPagination: (state, action) => {
      state.currentPagination = action.payload;
    },
    setPaginationReset: (state, action) => {
      state.paginationReset = action.payload;
    },
    setAppError: (state, action) => {
      state.appErrors.push({
        ...action.payload,
        id: Math.floor(Math.random() * Date.now()),
      });
      if (state.appErrors.length > 5) {
        state.appErrors.shift();
      }
    },
    removeAppError: (state, action) => {
      const errors = state.appErrors.filter((e) => e.id !== action.payload);
      state.appErrors = errors;
    },
    setDownloadState: (state, action) => {
      state.downloadState = action.payload;
    },
    setWorkflowIndex: (state, action) => {
      state.index = action.payload;
    },
    setWorkflowAction: (state, action) => {
      state.action = action.payload;
    },
  },
});

export const {
  setUser,
  setPage,
  setAppError,
  setCurrentPagination,
  setPaginationReset,
  removeAppError,
  setDownloadState,
  setBreadCrumb,
  setWorkflowIndex,
  setWorkflowAction
} = authSlice.actions;

export default authSlice.reducer;
